import { Pipe, PipeTransform } from '@angular/core';
import { SelectAllConfigInterface } from './models';

@Pipe({
    name: 'isSelectAllShow',
    standalone: false
})
export class IsSelectAllShowPipe<T> implements PipeTransform {
    transform(filteredItems: T[], inputValue: string, selectAllConfig: SelectAllConfigInterface, selectedItemsLength: number): boolean {
        return selectAllConfig.showSelectAll
            && (inputValue?.length || 0) >= selectAllConfig.minInputValue
            && filteredItems?.length > 1
            && (selectAllConfig.maxListLength ? (filteredItems?.length + selectedItemsLength) <= selectAllConfig.maxListLength : true);
    }
}
